import Button from '../common/Button';

function MobileToggle({ currentView, onViewChange }) {
    return (
        <div className="mobile-toggle">
            <div className="toggle-buttons">
                <Button
                    onClick={() => onViewChange('list')}
                    variant={currentView === 'list' ? 'primary' : 'secondary'}
                    size="medium"
                    className="toggle-btn"
                >
                    📝 List
                </Button>
                <Button
                    onClick={() => onViewChange('map')}
                    variant={currentView === 'map' ? 'primary' : 'secondary'}
                    size="medium"
                    className="toggle-btn"
                >
                    🗺️ Map
                </Button>
            </div>
        </div>
    );
}

export default MobileToggle;
